import { getString } from "utils/Utils";
import { FetchAvailableAppsSummaryEndAction } from "../actions/FetchAvailableAppsSummary";
import { OrgState } from "../state";

function isSameOrg(orgId1: string | { organizationId: string }, orgId2: string | { organizationId: string }) {
    const oid1 = getString(orgId1, "organizationId");
    const oid2 = getString(orgId2, "organizationId");
    return oid1 === oid2;
}

export function fetchAvailableAppsSummary(state: OrgState, action: FetchAvailableAppsSummaryEndAction) {
    const { error, organizationId, summary } = action.payload;
    const newState: Partial<OrgState> = {};
    if (isSameOrg(organizationId, state.currentOrg)) {
        newState.error = error;
        if (summary) {
            newState.currentAvailableAppsSummary = summary;
        }
    }
    return { ...state, ...newState };
}
